<template>
  <b-container fluid class="settings">
    <b-row>
      <b-col>
        <div class="text-left text-uppercase title p-3">
          Settings
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Phone Number" v-model="mphoneNumber" :disabled="!editingPhoneNumber">
          <div class="prefixIcon"><i class="material-icons">phone</i></div>
        </div>
        <div class="sectionTitle">Company Phone Number</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('cPhoneNumber')" v-if="!editingPhoneNumber">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('cPhoneNumber', mphoneNumber)" v-if="editingPhoneNumber">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Homepage title top" v-model="mHomeTitleTop" :disabled="!editingContent.homeTitleTop">
          <div class="prefixIcon"><i class="material-icons">short_text</i></div>
        </div>
        <div class="sectionTitle">Homepage Title Top</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('homeTitleTop')" v-if="!editingContent.homeTitleTop">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('homeTitleTop', mHomeTitleTop)" v-if="editingContent.homeTitleTop">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Homepage title middle" v-model="mhomeTitleMid" :disabled="!editingContent.homeTitleMid">
          <div class="prefixIcon"><i class="material-icons">short_text</i></div>
        </div>
        <div class="sectionTitle">Homepage Title Middle</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('homeTitleMid')" v-if="!editingContent.homeTitleMid">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('homeTitleMid', mhomeTitleMid)" v-if="editingContent.homeTitleMid">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Homepage title bottom" v-model="mhomeTitleBot" :disabled="!editingContent.homeTitleBot">
          <div class="prefixIcon"><i class="material-icons">short_text</i></div>
        </div>
        <div class="sectionTitle">Homepage Title Bottom</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('homeTitleBot')" v-if="!editingContent.homeTitleBot">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('homeTitleBot', mhomeTitleBot)" v-if="editingContent.homeTitleBot">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Homepage dynamic text 1" v-model="mhomeDynamicText1" :disabled="!editingContent.homeDynamicText1">
          <div class="prefixIcon"><i class="material-icons">short_text</i></div>
        </div>
        <div class="sectionTitle">Homepage Dynamic Text 1</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('homeDynamicText1')" v-if="!editingContent.homeDynamicText1">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('homeDynamicText1', mhomeDynamicText1)" v-if="editingContent.homeDynamicText1">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Homepage dynamic text 1" v-model="mhomeDynamicText2" :disabled="!editingContent.homeDynamicText2">
          <div class="prefixIcon"><i class="material-icons">short_text</i></div>
        </div>
        <div class="sectionTitle">Homepage Dynamic Text 2</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('homeDynamicText2')" v-if="!editingContent.homeDynamicText2">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('homeDynamicText2', mhomeDynamicText2)" v-if="editingContent.homeDynamicText2">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Homepage dynamic text 3" v-model="mhomeDynamicText3" :disabled="!editingContent.homeDynamicText3">
          <div class="prefixIcon"><i class="material-icons">short_text</i></div>
        </div>
        <div class="sectionTitle">Homepage Dynamic Text 3</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('homeDynamicText3')" v-if="!editingContent.homeDynamicText3">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('homeDynamicText3', mhomeDynamicText3)" v-if="editingContent.homeDynamicText3">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About title top" v-model="maboutTitleTop" :disabled="!editingContent.aboutTitleTop">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Title Top</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutTitleTop')" v-if="!editingContent.aboutTitleTop">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutTitleTop', maboutTitleTop)" v-if="editingContent.aboutTitleTop">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About title middle" v-model="maboutTitleMid" :disabled="!editingContent.aboutTitleMid">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Title Middle</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutTitleMid')" v-if="!editingContent.aboutTitleMid">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutTitleMid', maboutTitleMid)" v-if="editingContent.aboutTitleMid">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About title bottom" v-model="maboutTitleBot" :disabled="!editingContent.aboutTitleBot">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Title Bottom</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutTitleBot')" v-if="!editingContent.aboutTitleBot">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutTitleBot', maboutTitleBot)" v-if="editingContent.aboutTitleBot">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About Why Us Title" v-model="maboutDynamicText1" :disabled="!editingContent.aboutDynamicText1">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Why Us Title</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutDynamicText1')" v-if="!editingContent.aboutDynamicText1">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutDynamicText1', maboutDynamicText1)" v-if="editingContent.aboutDynamicText1">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About Why Us Description" v-model="maboutDynamicText2" :disabled="!editingContent.aboutDynamicText2">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Why Us Description</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutDynamicText2')" v-if="!editingContent.aboutDynamicText2">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutDynamicText2', maboutDynamicText2)" v-if="editingContent.aboutDynamicText2">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About Why Us Point 1 Title" v-model="maboutWhyUsTitle1" :disabled="!editingContent.aboutWhyUsTitle1">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Why Us Point 1 Title</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutWhyUsTitle1')" v-if="!editingContent.aboutWhyUsTitle1">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutWhyUsTitle1', maboutWhyUsTitle1)" v-if="editingContent.aboutWhyUsTitle1">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About Why Us Point 1 Description" v-model="maboutWhyUsDescription1" :disabled="!editingContent.aboutWhyUsDescription1">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Why Us Point 1 Description</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutWhyUsDescription1')" v-if="!editingContent.aboutWhyUsDescription1">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutWhyUsDescription1', maboutWhyUsDescription1)" v-if="editingContent.aboutWhyUsDescription1">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About Why Us Point 2 Title" v-model="maboutWhyUsTitle2" :disabled="!editingContent.aboutWhyUsTitle2">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Why Us Point 2 Title</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutWhyUsTitle2')" v-if="!editingContent.aboutWhyUsTitle2">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutWhyUsTitle2', maboutWhyUsTitle2)" v-if="editingContent.aboutWhyUsTitle2">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About Why Us Point 2 Description" v-model="maboutWhyUsDescription2" :disabled="!editingContent.aboutWhyUsDescription2">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Why Us Point 2 Description</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutWhyUsDescription2')" v-if="!editingContent.aboutWhyUsDescription2">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutWhyUsDescription2', maboutWhyUsDescription2)" v-if="editingContent.aboutWhyUsDescription2">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About Why Us Point 3 Title" v-model="maboutWhyUsTitle3" :disabled="!editingContent.aboutWhyUsTitle3">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Why Us Point 3 Title</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutWhyUsTitle3')" v-if="!editingContent.aboutWhyUsTitle3">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutWhyUsTitle3', maboutWhyUsTitle3)" v-if="editingContent.aboutWhyUsTitle3">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About Why Us Point 3 Description" v-model="maboutWhyUsDescription3" :disabled="!editingContent.aboutWhyUsDescription3">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Why Us Point 3 Description</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutWhyUsDescription3')" v-if="!editingContent.aboutWhyUsDescription3">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutWhyUsDescription3', maboutWhyUsDescription3)" v-if="editingContent.aboutWhyUsDescription3">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About Why Us Point 4 Title" v-model="maboutWhyUsTitle4" :disabled="!editingContent.aboutWhyUsTitle4">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Why Us Point 4 Title</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutWhyUsTitle4')" v-if="!editingContent.aboutWhyUsTitle4">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutWhyUsTitle4', maboutWhyUsTitle4)" v-if="editingContent.aboutWhyUsTitle4">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About Why Us Point 4 Description" v-model="maboutWhyUsDescription4" :disabled="!editingContent.aboutWhyUsDescription4">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Why Us Point 4 Description</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutWhyUsDescription4')" v-if="!editingContent.aboutWhyUsDescription4">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutWhyUsDescription4', maboutWhyUsDescription4)" v-if="editingContent.aboutWhyUsDescription4">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Title 1" v-model="mvisionMissionTitle1" :disabled="!editingContent.visionMissionTitle1">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Title 1</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionTitle1')" v-if="!editingContent.visionMissionTitle1">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionTitle1', mvisionMissionTitle1)" v-if="editingContent.visionMissionTitle1">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Description 1" v-model="mvisionMissionDescription1" :disabled="!editingContent.visionMissionDescription1">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Description 1</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionDescription1')" v-if="!editingContent.visionMissionDescription1">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionDescription1', mvisionMissionDescription1)" v-if="editingContent.visionMissionDescription1">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Title 2" v-model="mvisionMissionTitle2" :disabled="!editingContent.visionMissionTitle2">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Title 2</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionTitle2')" v-if="!editingContent.visionMissionTitle2">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionTitle2', mvisionMissionTitle2)" v-if="editingContent.visionMissionTitle2">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Description 2" v-model="mvisionMissionDescription2" :disabled="!editingContent.visionMissionDescription2">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Description 2</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionDescription2')" v-if="!editingContent.visionMissionDescription2">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionDescription2', mvisionMissionDescription2)" v-if="editingContent.visionMissionDescription2">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Title 3" v-model="mvisionMissionTitle3" :disabled="!editingContent.visionMissionTitle3">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Title 3</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionTitle3')" v-if="!editingContent.visionMissionTitle3">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionTitle3', mvisionMissionTitle3)" v-if="editingContent.visionMissionTitle3">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Description 3" v-model="mvisionMissionDescription3" :disabled="!editingContent.visionMissionDescription3">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Description 3</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionDescription3')" v-if="!editingContent.visionMissionDescription3">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionDescription3', mvisionMissionDescription3)" v-if="editingContent.visionMissionDescription3">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Title 4" v-model="mvisionMissionTitle4" :disabled="!editingContent.visionMissionTitle4">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Title 4</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionTitle4')" v-if="!editingContent.visionMissionTitle4">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionTitle4', mvisionMissionTitle4)" v-if="editingContent.visionMissionTitle4">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Description 4" v-model="mvisionMissionDescription4" :disabled="!editingContent.visionMissionDescription4">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Description 4</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionDescription4')" v-if="!editingContent.visionMissionDescription4">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionDescription4', mvisionMissionDescription4)" v-if="editingContent.visionMissionDescription4">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Title 5" v-model="mvisionMissionTitle5" :disabled="!editingContent.visionMissionTitle5">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Title 5</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionTitle5')" v-if="!editingContent.visionMissionTitle5">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionTitle5', mvisionMissionTitle5)" v-if="editingContent.visionMissionTitle5">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Description 5" v-model="mvisionMissionDescription5" :disabled="!editingContent.visionMissionDescription5">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Description 5</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionDescription5')" v-if="!editingContent.visionMissionDescription5">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionDescription5', mvisionMissionDescription5)" v-if="editingContent.visionMissionDescription5">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Title 6" v-model="mvisionMissionTitle6" :disabled="!editingContent.visionMissionTitle6">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Title 6</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionTitle6')" v-if="!editingContent.visionMissionTitle6">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionTitle6', mvisionMissionTitle6)" v-if="editingContent.visionMissionTitle6">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Description 6" v-model="mvisionMissionDescription6" :disabled="!editingContent.visionMissionDescription6">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Description 6</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionDescription6')" v-if="!editingContent.visionMissionDescription6">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionDescription6', mvisionMissionDescription6)" v-if="editingContent.visionMissionDescription6">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Title 7" v-model="mvisionMissionTitle7" :disabled="!editingContent.visionMissionTitle7">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Title 7</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionTitle7')" v-if="!editingContent.visionMissionTitle7">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionTitle7', mvisionMissionTitle7)" v-if="editingContent.visionMissionTitle7">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Description 7" v-model="mvisionMissionDescription7" :disabled="!editingContent.visionMissionDescription7">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Description 7</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionDescription7')" v-if="!editingContent.visionMissionDescription7">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionDescription7', mvisionMissionDescription7)" v-if="editingContent.visionMissionDescription7">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Title 8" v-model="mvisionMissionTitle8" :disabled="!editingContent.visionMissionTitle8">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Title 8</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionTitle8')" v-if="!editingContent.visionMissionTitle8">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionTitle8', mvisionMissionTitle8)" v-if="editingContent.visionMissionTitle8">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Vision & Mission Description 8" v-model="mvisionMissionDescription8" :disabled="!editingContent.visionMissionDescription8">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Vision & Mission Description 8</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('visionMissionDescription8')" v-if="!editingContent.visionMissionDescription8">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('visionMissionDescription8', mvisionMissionDescription8)" v-if="editingContent.visionMissionDescription8">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service title top" v-model="mserviceTitleTop" :disabled="!editingContent.serviceTitleTop">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Title Top</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceTitleTop')" v-if="!editingContent.serviceTitleTop">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceTitleTop', mserviceTitleTop)" v-if="editingContent.serviceTitleTop">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service title middle" v-model="mserviceTitleMid" :disabled="!editingContent.serviceTitleMid">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Title Middle</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceTitleMid')" v-if="!editingContent.serviceTitleMid">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceTitleMid', mserviceTitleMid)" v-if="editingContent.serviceTitleMid">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service title bottom" v-model="mserviceTitleBot" :disabled="!editingContent.serviceTitleBot">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Title Bottom</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceTitleBot')" v-if="!editingContent.serviceTitleBot">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceTitleBot', mserviceTitleBot)" v-if="editingContent.serviceTitleBot">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service Dynamic Text 1" v-model="mserviceDynamicText1" :disabled="!editingContent.serviceDynamicText1">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Dyamic Text 1</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceDynamicText1')" v-if="!editingContent.serviceDynamicText1">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceDynamicText1', mserviceDynamicText1)" v-if="editingContent.serviceDynamicText1">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service Dynamic Text 2" v-model="mserviceDynamicText2" :disabled="!editingContent.serviceDynamicText2">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Dyamic Text 2</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceDynamicText2')" v-if="!editingContent.serviceDynamicText2">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceDynamicText2', mserviceDynamicText2)" v-if="editingContent.serviceDynamicText2">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service Dynamic Text 3" v-model="mserviceDynamicText3" :disabled="!editingContent.serviceDynamicText3">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Dyamic Text 3</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceDynamicText3')" v-if="!editingContent.serviceDynamicText3">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceDynamicText3', mserviceDynamicText3)" v-if="editingContent.serviceDynamicText3">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service Dynamic Text 4" v-model="mserviceDynamicText4" :disabled="!editingContent.serviceDynamicText4">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Dyamic Text 4</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceDynamicText4')" v-if="!editingContent.serviceDynamicText4">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceDynamicText4', mserviceDynamicText4)" v-if="editingContent.serviceDynamicText4">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service Dynamic Text 5" v-model="mserviceDynamicText5" :disabled="!editingContent.serviceDynamicText5">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Dyamic Text 5</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceDynamicText5')" v-if="!editingContent.serviceDynamicText5">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceDynamicText5', mserviceDynamicText5)" v-if="editingContent.serviceDynamicText5">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service Dynamic Text 6" v-model="mserviceDynamicText6" :disabled="!editingContent.serviceDynamicText6">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Dyamic Text 6</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceDynamicText6')" v-if="!editingContent.serviceDynamicText6">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceDynamicText6', mserviceDynamicText6)" v-if="editingContent.serviceDynamicText6">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service Dynamic Text 7" v-model="mserviceDynamicText7" :disabled="!editingContent.serviceDynamicText7">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Dyamic Text 7</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceDynamicText7')" v-if="!editingContent.serviceDynamicText7">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceDynamicText7', mserviceDynamicText7)" v-if="editingContent.serviceDynamicText7">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service Dynamic Text 8" v-model="mserviceDynamicText8" :disabled="!editingContent.serviceDynamicText8">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Dyamic Text 8</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceDynamicText8')" v-if="!editingContent.serviceDynamicText8">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceDynamicText8', mserviceDynamicText8)" v-if="editingContent.serviceDynamicText8">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service Dynamic Text 9" v-model="mserviceDynamicText9" :disabled="!editingContent.serviceDynamicText9">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Dyamic Text 9</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceDynamicText9')" v-if="!editingContent.serviceDynamicText9">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceDynamicText9', mserviceDynamicText9)" v-if="editingContent.serviceDynamicText9">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service Dynamic Text 10" v-model="mserviceDynamicText10" :disabled="!editingContent.serviceDynamicText10">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Dyamic Text 10</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceDynamicText10')" v-if="!editingContent.serviceDynamicText10">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceDynamicText10', mserviceDynamicText10)" v-if="editingContent.serviceDynamicText10">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service Dynamic Text 11" v-model="mserviceDynamicText11" :disabled="!editingContent.serviceDynamicText11">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Dyamic Text 11</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceDynamicText11')" v-if="!editingContent.serviceDynamicText11">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceDynamicText11', mserviceDynamicText11)" v-if="editingContent.serviceDynamicText11">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service Dynamic Text 12" v-model="mserviceDynamicText12" :disabled="!editingContent.serviceDynamicText12">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Dyamic Text 12</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceDynamicText12')" v-if="!editingContent.serviceDynamicText12">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceDynamicText12', mserviceDynamicText12)" v-if="editingContent.serviceDynamicText12">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Service Dynamic Text 13" v-model="mserviceDynamicText13" :disabled="!editingContent.serviceDynamicText13">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Service Dyamic Text 13</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('serviceDynamicText13')" v-if="!editingContent.serviceDynamicText13">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('serviceDynamicText13', mserviceDynamicText13)" v-if="editingContent.serviceDynamicText13">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Project Title Top" v-model="mprojectTitleTop" :disabled="!editingContent.projectTitleTop">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Project Title Top</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('projectTitleTop')" v-if="!editingContent.projectTitleTop">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('projectTitleTop', mprojectTitleTop)" v-if="editingContent.projectTitleTop">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Project Title Middle" v-model="mprojectTitleMid" :disabled="!editingContent.projectTitleMid">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Project Title Middle</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('projectTitleMid')" v-if="!editingContent.projectTitleMid">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('projectTitleMid', mprojectTitleMid)" v-if="editingContent.projectTitleMid">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Project Title Bottom" v-model="mprojectTitleBot" :disabled="!editingContent.projectTitleBot">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Project Title Bottom</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('projectTitleBot')" v-if="!editingContent.projectTitleBot">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('projectTitleBot', mprojectTitleBot)" v-if="editingContent.projectTitleBot">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Product Title Top" v-model="mproductTitleTop" :disabled="!editingContent.productTitleTop">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Product Title Top</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('productTitleTop')" v-if="!editingContent.productTitleTop">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('productTitleTop', mproductTitleTop)" v-if="editingContent.productTitleTop">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Product Title Middle" v-model="mproductTitleMid" :disabled="!editingContent.productTitleMid">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Product Title Middle</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('productTitleMid')" v-if="!editingContent.productTitleMid">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('productTitleMid', mproductTitleMid)" v-if="editingContent.productTitleMid">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Product Title Bottom" v-model="mproductTitleBot" :disabled="!editingContent.productTitleBot">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Product Title Bottom</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('productTitleBot')" v-if="!editingContent.productTitleBot">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('productTitleBot', mproductTitleBot)" v-if="editingContent.productTitleBot">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Contact Title Middle" v-model="mcontactTitleMid" :disabled="!editingContent.contactTitleMid">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Contact Title Middle</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('contactTitleMid')" v-if="!editingContent.contactTitleMid">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('contactTitleMid', mcontactTitleMid)" v-if="editingContent.contactTitleMid">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Contact Title Bottom" v-model="mcontactTitleBot" :disabled="!editingContent.contactTitleBot">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Contact Title Bottom</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('contactTitleBot')" v-if="!editingContent.contactTitleBot">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('contactTitleBot', mcontactTitleBot)" v-if="editingContent.contactTitleBot">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Contact Dynamic Text 1" v-model="mcontactDynamicText1" :disabled="!editingContent.contactDynamicText1">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Contact Dynamic Text 1</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('contactDynamicText1')" v-if="!editingContent.contactDynamicText1">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('contactDynamicText1', mcontactDynamicText1)" v-if="editingContent.contactDynamicText1">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Contact Dynamic Text 2" v-model="mcontactDynamicText2" :disabled="!editingContent.contactDynamicText2">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Contact Dynamic Text 2</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('contactDynamicText2')" v-if="!editingContent.contactDynamicText2">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('contactDynamicText2', mcontactDynamicText2)" v-if="editingContent.contactDynamicText2">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Contact Dynamic Text 3" v-model="mcontactDynamicText3" :disabled="!editingContent.contactDynamicText3">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Contact Dynamic Text 3</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('contactDynamicText3')" v-if="!editingContent.contactDynamicText3">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('contactDynamicText3', mcontactDynamicText3)" v-if="editingContent.contactDynamicText3">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Contact Dynamic Text 4" v-model="mcontactDynamicText4" :disabled="!editingContent.contactDynamicText4">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Contact Dynamic Text 4</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('contactDynamicText4')" v-if="!editingContent.contactDynamicText4">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('contactDynamicText4', mcontactDynamicText4)" v-if="editingContent.contactDynamicText4">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="About Us Footer" v-model="maboutUsFooter" :disabled="!editingContent.aboutUsFooter">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">About Us Footer</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('aboutUsFooter')" v-if="!editingContent.aboutUsFooter">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('aboutUsFooter', maboutUsFooter)" v-if="editingContent.aboutUsFooter">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Subscribe Footer" v-model="msubscribeFooter" :disabled="!editingContent.subscribeFooter">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Subscribe Footer</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('subscribeFooter')" v-if="!editingContent.subscribeFooter">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('subscribeFooter', msubscribeFooter)" v-if="editingContent.subscribeFooter">
          Save
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="11" md="11" sm="12" xs="12" class="box mt-3 text-left">
        <div class="fieldWrapper">
          <input type="text" placeholder="Social Media Footer" v-model="msocialMediaFooter" :disabled="!editingContent.socialMediaFooter">
          <div class="prefixIcon"><i class="material-icons">sort</i></div>
        </div>
        <div class="sectionTitle">Social Media Footer</div>
      </b-col>
      <b-col lg="1" md="1" sm="12" xs="12" class="box mt-3 text-left">
        <div class="text-center text-uppercase actionBtn" v-on:click="editContent('socialMediaFooter')" v-if="!editingContent.socialMediaFooter">
          Edit
        </div>
        <div class="text-center text-uppercase actionBtn" v-on:click="saveContentById('socialMediaFooter', msocialMediaFooter)" v-if="editingContent.socialMediaFooter">
          Save
        </div>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'Settings',
  data () {
    return {
      errors: [],
      isLoading: false,
      editingPhoneNumber: false,
      editingContent: {
        homeTitleTop: false,
        homeTitleMid: false,
        homeTitleBot: false,
        homeDynamicText1: false,
        homeDynamicText2: false,
        homeDynamicText3: false,
        aboutTitleTop: false,
        aboutTitleMid: false,
        aboutTitleBot: false,
        aboutDynamicText1: false,
        aboutDynamicText2: false,
        aboutWhyUsTitle1: false,
        aboutWhyUsDescription1: false,
        aboutWhyUsTitle2: false,
        aboutWhyUsDescription2: false,
        aboutWhyUsTitle3: false,
        aboutWhyUsDescription3: false,
        aboutWhyUsTitle4: false,
        aboutWhyUsDescription4: false,
        visionMissionTitle1: false,
        visionMissionDescription1: false,
        visionMissionTitle2: false,
        visionMissionDescription2: false,
        visionMissionTitle3: false,
        visionMissionDescription3: false,
        visionMissionTitle4: false,
        visionMissionDescription4: false,
        visionMissionTitle5: false,
        visionMissionDescription5: false,
        visionMissionTitle6: false,
        visionMissionDescription6: false,
        visionMissionTitle7: false,
        visionMissionDescription7: false,
        visionMissionTitle8: false,
        visionMissionDescription8: false,
        serviceTitleTop: false,
        serviceTitleMid: false,
        serviceTitleBot: false,
        serviceDynamicText1: false,
        serviceDynamicText2: false,
        serviceDynamicText3: false,
        serviceDynamicText4: false,
        serviceDynamicText5: false,
        serviceDynamicText6: false,
        serviceDynamicText7: false,
        serviceDynamicText8: false,
        serviceDynamicText9: false,
        serviceDynamicText10: false,
        serviceDynamicText11: false,
        serviceDynamicText12: false,
        serviceDynamicText13: false,
        projectTitleTop: false,
        projectTitleMid: false,
        projectTitleBot: false,
        productTitleTop: false,
        productTitleMid: false,
        productTitleBot: false,
        contactTitleMid: false,
        contactTitleBot: false,
        contactDynamicText1: false,
        contactDynamicText2: false,
        contactDynamicText3: false,
        contactDynamicText4: false,
        aboutUsFooter: false,
        subscribeFooter: false,
        socialMediaFooter: false
      },
      mphoneNumber: null,
      mHomeTitleTop: null,
      mhomeTitleTop: null,
      mhomeTitleMid: null,
      mhomeTitleBot: null,
      mhomeDynamicText1: null,
      mhomeDynamicText2: null,
      mhomeDynamicText3: null,
      maboutTitleTop: null,
      maboutTitleMid: null,
      maboutTitleBot: null,
      maboutDynamicText1: null,
      maboutDynamicText2: null,
      maboutWhyUsTitle1: null,
      maboutWhyUsDescription1: null,
      maboutWhyUsTitle2: null,
      maboutWhyUsDescription2: null,
      maboutWhyUsTitle3: null,
      maboutWhyUsDescription3: null,
      maboutWhyUsTitle4: null,
      maboutWhyUsDescription4: null,
      mvisionMissionTitle1: null,
      mvisionMissionDescription1: null,
      mvisionMissionTitle2: null,
      mvisionMissionDescription2: null,
      mvisionMissionTitle3: null,
      mvisionMissionDescription3: null,
      mvisionMissionTitle4: null,
      mvisionMissionDescription4: null,
      mvisionMissionTitle5: null,
      mvisionMissionDescription5: null,
      mvisionMissionTitle6: null,
      mvisionMissionDescription6: null,
      mvisionMissionTitle7: null,
      mvisionMissionDescription7: null,
      mvisionMissionTitle8: null,
      mvisionMissionDescription8: null,
      mserviceTitleTop: null,
      mserviceTitleMid: null,
      mserviceTitleBot: null,
      mserviceDynamicText1: null,
      mserviceDynamicText2: null,
      mserviceDynamicText3: null,
      mserviceDynamicText4: null,
      mserviceDynamicText5: null,
      mserviceDynamicText6: null,
      mserviceDynamicText7: null,
      mserviceDynamicText8: null,
      mserviceDynamicText9: null,
      mserviceDynamicText10: null,
      mserviceDynamicText11: null,
      mserviceDynamicText12: null,
      mserviceDynamicText13: null,
      mprojectTitleTop: null,
      mprojectTitleMid: null,
      mprojectTitleBot: null,
      mproductTitleTop: null,
      mproductTitleMid: null,
      mproductTitleBot: null,
      mcontactTitleMid: null,
      mcontactTitleBot: null,
      mcontactDynamicText1: null,
      mcontactDynamicText2: null,
      mcontactDynamicText3: null,
      mcontactDynamicText4: null,
      maboutUsFooter: null,
      msubscribeFooter: null,
      msocialMediaFooter: null
    }
  },
  methods: {
    editingToFalse () {
      this.$data.editingPhoneNumber = false
      this.$data.editingContent.homeTitleTop = false
      this.$data.editingContent.homeTitleMid = false
      this.$data.editingContent.homeTitleBot = false
      this.$data.editingContent.homeDynamicText1 = false
      this.$data.editingContent.homeDynamicText2 = false
      this.$data.editingContent.homeDynamicText3 = false
      this.$data.editingContent.aboutTitleTop = false
      this.$data.editingContent.aboutTitleMid = false
      this.$data.editingContent.aboutTitleBot = false
      this.$data.editingContent.aboutDynamicText1 = false
      this.$data.editingContent.aboutDynamicText2 = false
      this.$data.editingContent.aboutWhyUsTitle1 = false
      this.$data.editingContent.aboutWhyUsDescription1 = false
      this.$data.editingContent.aboutWhyUsTitle2 = false
      this.$data.editingContent.aboutWhyUsDescription2 = false
      this.$data.editingContent.aboutWhyUsTitle3 = false
      this.$data.editingContent.aboutWhyUsDescription3 = false
      this.$data.editingContent.aboutWhyUsTitle4 = false
      this.$data.editingContent.aboutWhyUsDescription4 = false
      this.$data.editingContent.visionMissionTitle1 = false
      this.$data.editingContent.visionMissionDescription1 = false
      this.$data.editingContent.visionMissionTitle2 = false
      this.$data.editingContent.visionMissionDescription2 = false
      this.$data.editingContent.visionMissionTitle3 = false
      this.$data.editingContent.visionMissionDescription3 = false
      this.$data.editingContent.visionMissionTitle4 = false
      this.$data.editingContent.visionMissionDescription4 = false
      this.$data.editingContent.visionMissionTitle5 = false
      this.$data.editingContent.visionMissionDescription5 = false
      this.$data.editingContent.visionMissionTitle6 = false
      this.$data.editingContent.visionMissionDescription6 = false
      this.$data.editingContent.visionMissionTitle7 = false
      this.$data.editingContent.visionMissionDescription7 = false
      this.$data.editingContent.visionMissionTitle8 = false
      this.$data.editingContent.visionMissionDescription8 = false
      this.$data.editingContent.serviceTitleTop = false
      this.$data.editingContent.serviceTitleMid = false
      this.$data.editingContent.serviceTitleBot = false
      this.$data.editingContent.serviceDynamicText1 = false
      this.$data.editingContent.serviceDynamicText2 = false
      this.$data.editingContent.serviceDynamicText3 = false
      this.$data.editingContent.serviceDynamicText4 = false
      this.$data.editingContent.serviceDynamicText5 = false
      this.$data.editingContent.serviceDynamicText6 = false
      this.$data.editingContent.serviceDynamicText7 = false
      this.$data.editingContent.serviceDynamicText8 = false
      this.$data.editingContent.serviceDynamicText9 = false
      this.$data.editingContent.serviceDynamicText10 = false
      this.$data.editingContent.serviceDynamicText11 = false
      this.$data.editingContent.serviceDynamicText12 = false
      this.$data.editingContent.serviceDynamicText13 = false
      this.$data.editingContent.projectTitleTop = false
      this.$data.editingContent.projectTitleMid = false
      this.$data.editingContent.projectTitleBot = false
      this.$data.editingContent.productTitleTop = false
      this.$data.editingContent.productTitleMid = false
      this.$data.editingContent.productTitleBot = false
      this.$data.editingContent.contactTitleMid = false
      this.$data.editingContent.contactTitleBot = false
      this.$data.editingContent.contactDynamicText1 = false
      this.$data.editingContent.contactDynamicText2 = false
      this.$data.editingContent.contactDynamicText3 = false
      this.$data.editingContent.contactDynamicText4 = false
      this.$data.editingContent.aboutUsFooter = false
      this.$data.editingContent.subscribeFooter = false
      this.$data.editingContent.socialMediaFooter = false
    },
    editContent (id) {
      if (id === 'cPhoneNumber') {
        this.$data.editingPhoneNumber = true
      } else if (id === 'homeTitleTop') {
        this.$data.editingContent.homeTitleTop = true
      } else if (id === 'homeTitleMid') {
        this.$data.editingContent.homeTitleMid = true
      } else if (id === 'homeTitleBot') {
        this.$data.editingContent.homeTitleBot = true
      } else if (id === 'homeDynamicText1') {
        this.$data.editingContent.homeDynamicText1 = true
      } else if (id === 'homeDynamicText2') {
        this.$data.editingContent.homeDynamicText2 = true
      } else if (id === 'homeDynamicText3') {
        this.$data.editingContent.homeDynamicText3 = true
      } else if (id === 'aboutTitleTop') {
        this.$data.editingContent.aboutTitleTop = true
      } else if (id === 'aboutTitleMid') {
        this.$data.editingContent.aboutTitleMid = true
      } else if (id === 'aboutTitleBot') {
        this.$data.editingContent.aboutTitleBot = true
      } else if (id === 'aboutDynamicText1') {
        this.$data.editingContent.aboutDynamicText1 = true
      } else if (id === 'aboutDynamicText2') {
        this.$data.editingContent.aboutDynamicText2 = true
      } else if (id === 'aboutWhyUsTitle1') {
        this.$data.editingContent.aboutWhyUsTitle1 = true
      } else if (id === 'aboutWhyUsDescription1') {
        this.$data.editingContent.aboutWhyUsDescription1 = true
      } else if (id === 'aboutWhyUsTitle2') {
        this.$data.editingContent.aboutWhyUsTitle2 = true
      } else if (id === 'aboutWhyUsDescription2') {
        this.$data.editingContent.aboutWhyUsDescription2 = true
      } else if (id === 'aboutWhyUsTitle3') {
        this.$data.editingContent.aboutWhyUsTitle3 = true
      } else if (id === 'aboutWhyUsDescription3') {
        this.$data.editingContent.aboutWhyUsDescription3 = true
      } else if (id === 'aboutWhyUsTitle4') {
        this.$data.editingContent.aboutWhyUsTitle4 = true
      } else if (id === 'aboutWhyUsDescription4') {
        this.$data.editingContent.aboutWhyUsDescription4 = true
      } else if (id === 'visionMissionTitle1') {
        this.$data.editingContent.visionMissionTitle1 = true
      } else if (id === 'visionMissionDescription1') {
        this.$data.editingContent.visionMissionDescription1 = true
      } else if (id === 'visionMissionTitle2') {
        this.$data.editingContent.visionMissionTitle2 = true
      } else if (id === 'visionMissionDescription2') {
        this.$data.editingContent.visionMissionDescription2 = true
      } else if (id === 'visionMissionTitle3') {
        this.$data.editingContent.visionMissionTitle3 = true
      } else if (id === 'visionMissionDescription3') {
        this.$data.editingContent.visionMissionDescription3 = true
      } else if (id === 'visionMissionTitle4') {
        this.$data.editingContent.visionMissionTitle4 = true
      } else if (id === 'visionMissionDescription4') {
        this.$data.editingContent.visionMissionDescription4 = true
      } else if (id === 'visionMissionTitle5') {
        this.$data.editingContent.visionMissionTitle5 = true
      } else if (id === 'visionMissionDescription5') {
        this.$data.editingContent.visionMissionDescription5 = true
      } else if (id === 'visionMissionTitle6') {
        this.$data.editingContent.visionMissionTitle6 = true
      } else if (id === 'visionMissionDescription6') {
        this.$data.editingContent.visionMissionDescription6 = true
      } else if (id === 'visionMissionTitle7') {
        this.$data.editingContent.visionMissionTitle7 = true
      } else if (id === 'visionMissionDescription7') {
        this.$data.editingContent.visionMissionDescription7 = true
      } else if (id === 'visionMissionTitle8') {
        this.$data.editingContent.visionMissionTitle8 = true
      } else if (id === 'visionMissionDescription8') {
        this.$data.editingContent.visionMissionDescription8 = true
      } else if (id === 'serviceTitleTop') {
        this.$data.editingContent.serviceTitleTop = true
      } else if (id === 'serviceTitleMid') {
        this.$data.editingContent.serviceTitleMid = true
      } else if (id === 'serviceTitleBot') {
        this.$data.editingContent.serviceTitleBot = true
      } else if (id === 'serviceDynamicText1') {
        this.$data.editingContent.serviceDynamicText1 = true
      } else if (id === 'serviceDynamicText2') {
        this.$data.editingContent.serviceDynamicText2 = true
      } else if (id === 'serviceDynamicText3') {
        this.$data.editingContent.serviceDynamicText3 = true
      } else if (id === 'serviceDynamicText4') {
        this.$data.editingContent.serviceDynamicText4 = true
      } else if (id === 'serviceDynamicText5') {
        this.$data.editingContent.serviceDynamicText5 = true
      } else if (id === 'serviceDynamicText6') {
        this.$data.editingContent.serviceDynamicText6 = true
      } else if (id === 'serviceDynamicText7') {
        this.$data.editingContent.serviceDynamicText7 = true
      } else if (id === 'serviceDynamicText8') {
        this.$data.editingContent.serviceDynamicText8 = true
      } else if (id === 'serviceDynamicText9') {
        this.$data.editingContent.serviceDynamicText9 = true
      } else if (id === 'serviceDynamicText10') {
        this.$data.editingContent.serviceDynamicText10 = true
      } else if (id === 'serviceDynamicText11') {
        this.$data.editingContent.serviceDynamicText11 = true
      } else if (id === 'serviceDynamicText12') {
        this.$data.editingContent.serviceDynamicText12 = true
      } else if (id === 'serviceDynamicText13') {
        this.$data.editingContent.serviceDynamicText13 = true
      } else if (id === 'projectTitleTop') {
        this.$data.editingContent.projectTitleTop = true
      } else if (id === 'projectTitleMid') {
        this.$data.editingContent.projectTitleMid = true
      } else if (id === 'projectTitleBot') {
        this.$data.editingContent.projectTitleBot = true
      } else if (id === 'productTitleTop') {
        this.$data.editingContent.productTitleTop = true
      } else if (id === 'productTitleMid') {
        this.$data.editingContent.productTitleMid = true
      } else if (id === 'productTitleBot') {
        this.$data.editingContent.productTitleBot = true
      } else if (id === 'contactTitleMid') {
        this.$data.editingContent.contactTitleMid = true
      } else if (id === 'contactTitleBot') {
        this.$data.editingContent.contactTitleBot = true
      } else if (id === 'contactDynamicText1') {
        this.$data.editingContent.contactDynamicText1 = true
      } else if (id === 'contactDynamicText2') {
        this.$data.editingContent.contactDynamicText2 = true
      } else if (id === 'contactDynamicText3') {
        this.$data.editingContent.contactDynamicText3 = true
      } else if (id === 'contactDynamicText4') {
        this.$data.editingContent.contactDynamicText4 = true
      } else if (id === 'aboutUsFooter') {
        this.$data.editingContent.aboutUsFooter = true
      } else if (id === 'subscribeFooter') {
        this.$data.editingContent.subscribeFooter = true
      } else if (id === 'socialMediaFooter') {
        this.$data.editingContent.socialMediaFooter = true
      }
    },
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    },
    saveContentById (key, value) {
      const id = this.getIdByKey(key)
      this.$data.isLoading = true
      if (this.validateContent(value)) {
        this.$store.dispatch('saveContentById', {
          data: {
            id: id,
            content: { value },
            token: this.$cookies.get('a').jwt
          },
          success: (res) => {
            this.toast('Edit success.', 'success', 'check')
          },
          fail: () => {
            console.log('Edit failed.')
          }
        }).then(() => {
          this.$data.isLoading = false
          this.editingToFalse()
        }).catch(err => {
          console.error('error: ' + err)
        })
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline')
        this.isLoading = false
      }
    },
    validateContent (value) {
      if (value === '' || value.trim() === '') {
        this.$data.errors.push('Kolom tidak boleh kosong')
        return false
      } else {
        return true
      }
    },
    validatePhoneNumber (data) {
      return true
    },
    findContentById (id) {
      this.$data.isLoading = true
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: () => {
        },
        fail: () => {
          this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.$data.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    findAllContents () {
      this.isLoading = true
      this.$store.dispatch('findAllContents', {
        success: (res) => {
        },
        fail: () => {
          this.toast('Could not get contents. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    getIdByKey (key) {
      if (key === 'homeTitleTop') {
        return this.homeTitleTopId
      } else if (key === 'cPhoneNumber') {
        return this.phoneNumberId
      } else if (key === 'homeTitleTop') {
        return this.homeTitleTopId
      } else if (key === 'homeTitleMid') {
        return this.homeTitleMidId
      } else if (key === 'homeTitleBot') {
        return this.homeTitleBotId
      } else if (key === 'homeDynamicText1') {
        return this.homeDynamicText1Id
      } else if (key === 'homeDynamicText2') {
        return this.homeDynamicText2Id
      } else if (key === 'homeDynamicText3') {
        return this.homeDynamicText3Id
      } else if (key === 'aboutTitleTop') {
        return this.aboutTitleTopId
      } else if (key === 'aboutTitleMid') {
        return this.aboutTitleMidId
      } else if (key === 'aboutTitleBot') {
        return this.aboutTitleBotId
      } else if (key === 'aboutDynamicText1') {
        return this.aboutDynamicText1Id
      } else if (key === 'aboutDynamicText2') {
        return this.aboutDynamicText2Id
      } else if (key === 'aboutWhyUsTitle1') {
        return this.aboutWhyUsTitle1Id
      } else if (key === 'aboutWhyUsDescription1') {
        return this.aboutWhyUsDescription1Id
      } else if (key === 'aboutWhyUsTitle2') {
        return this.aboutWhyUsTitle2Id
      } else if (key === 'aboutWhyUsDescription2') {
        return this.aboutWhyUsDescription2Id
      } else if (key === 'aboutWhyUsTitle3') {
        return this.aboutWhyUsTitle3Id
      } else if (key === 'aboutWhyUsDescription3') {
        return this.aboutWhyUsDescription3Id
      } else if (key === 'aboutWhyUsTitle4') {
        return this.aboutWhyUsTitle4Id
      } else if (key === 'aboutWhyUsDescription4') {
        return this.aboutWhyUsDescription4Id
      } else if (key === 'visionMissionTitle1') {
        return this.visionMissionTitle1Id
      } else if (key === 'visionMissionDescription1') {
        return this.visionMissionDescription1Id
      } else if (key === 'visionMissionTitle2') {
        return this.visionMissionTitle2Id
      } else if (key === 'visionMissionDescription2') {
        return this.visionMissionDescription2Id
      } else if (key === 'visionMissionTitle3') {
        return this.visionMissionTitle3Id
      } else if (key === 'visionMissionDescription3') {
        return this.visionMissionDescription3Id
      } else if (key === 'visionMissionTitle4') {
        return this.visionMissionTitle4Id
      } else if (key === 'visionMissionDescription4') {
        return this.visionMissionDescription4Id
      } else if (key === 'visionMissionTitle5') {
        return this.visionMissionTitle5Id
      } else if (key === 'visionMissionDescription5') {
        return this.visionMissionDescription5Id
      } else if (key === 'visionMissionTitle6') {
        return this.visionMissionTitle6Id
      } else if (key === 'visionMissionDescription6') {
        return this.visionMissionDescription6Id
      } else if (key === 'visionMissionTitle7') {
        return this.visionMissionTitle7Id
      } else if (key === 'visionMissionDescription7') {
        return this.visionMissionDescription7Id
      } else if (key === 'visionMissionTitle8') {
        return this.visionMissionTitle8Id
      } else if (key === 'visionMissionDescription8') {
        return this.visionMissionDescription8Id
      } else if (key === 'serviceTitleTop') {
        return this.serviceTitleTopId
      } else if (key === 'serviceTitleMid') {
        return this.serviceTitleMidId
      } else if (key === 'serviceTitleBot') {
        return this.serviceTitleBotId
      } else if (key === 'serviceDynamicText1') {
        return this.serviceDynamicText1Id
      } else if (key === 'serviceDynamicText2') {
        return this.serviceDynamicText2Id
      } else if (key === 'serviceDynamicText3') {
        return this.serviceDynamicText3Id
      } else if (key === 'serviceDynamicText4') {
        return this.serviceDynamicText4Id
      } else if (key === 'serviceDynamicText5') {
        return this.serviceDynamicText5Id
      } else if (key === 'serviceDynamicText6') {
        return this.serviceDynamicText6Id
      } else if (key === 'serviceDynamicText7') {
        return this.serviceDynamicText7Id
      } else if (key === 'serviceDynamicText8') {
        return this.serviceDynamicText8Id
      } else if (key === 'serviceDynamicText9') {
        return this.serviceDynamicText9Id
      } else if (key === 'serviceDynamicText10') {
        return this.serviceDynamicText10Id
      } else if (key === 'serviceDynamicText11') {
        return this.serviceDynamicText11Id
      } else if (key === 'serviceDynamicText12') {
        return this.serviceDynamicText12Id
      } else if (key === 'serviceDynamicText13') {
        return this.serviceDynamicText13Id
      } else if (key === 'projectTitleTop') {
        return this.projectTitleTopId
      } else if (key === 'projectTitleMid') {
        return this.projectTitleMidId
      } else if (key === 'projectTitleBot') {
        return this.projectTitleBotId
      } else if (key === 'productTitleTop') {
        return this.productTitleTopId
      } else if (key === 'productTitleMid') {
        return this.productTitleMidId
      } else if (key === 'productTitleBot') {
        return this.productTitleBotId
      } else if (key === 'contactTitleMid') {
        return this.contactTitleMidId
      } else if (key === 'contactTitleBot') {
        return this.contactTitleBotId
      } else if (key === 'contactDynamicText1') {
        return this.contactDynamicText1Id
      } else if (key === 'contactDynamicText2') {
        return this.contactDynamicText2Id
      } else if (key === 'contactDynamicText3') {
        return this.contactDynamicText3Id
      } else if (key === 'contactDynamicText4') {
        return this.contactDynamicText4Id
      } else if (key === 'aboutUsFooter') {
        return this.aboutUsFooterId
      } else if (key === 'subscribeFooter') {
        return this.subscribeFooterId
      } else if (key === 'socialMediaFooter') {
        return this.socialMediaFooterId
      }
    }
  },
  created () {
    this.findAllContents()
    // this.findPhoneNumber()
    // this.findContentById('homeTitleTop')
    // this.findContentById('homeTitleMid')
    // this.findContentById('homeTitleBot')
    // this.findContentById('homeDynamicText1')
    // this.findContentById('homeDynamicText2')
    // this.findContentById('homeDynamicText3')
    // this.findContentById('aboutTitleTop')
    // this.findContentById('aboutTitleMid')
    // this.findContentById('aboutTitleBot')
    // this.findContentById('aboutDynamicText1')
    // this.findContentById('aboutDynamicText2')
    // this.findContentById('aboutWhyUsTitle1')
    // this.findContentById('aboutWhyUsDescription1')
    // this.findContentById('aboutWhyUsTitle2')
    // this.findContentById('aboutWhyUsDescription2')
    // this.findContentById('aboutWhyUsTitle3')
    // this.findContentById('aboutWhyUsDescription3')
    // this.findContentById('aboutWhyUsTitle4')
    // this.findContentById('aboutWhyUsDescription4')
    // this.findContentById('visionMissionTitle1')
    // this.findContentById('visionMissionDescription1')
    // this.findContentById('visionMissionTitle2')
    // this.findContentById('visionMissionDescription2')
    // this.findContentById('visionMissionTitle3')
    // this.findContentById('visionMissionDescription3')
    // this.findContentById('visionMissionTitle4')
    // this.findContentById('visionMissionDescription4')
    // this.findContentById('visionMissionTitle5')
    // this.findContentById('visionMissionDescription5')
    // this.findContentById('visionMissionTitle6')
    // this.findContentById('visionMissionDescription6')
    // this.findContentById('visionMissionTitle7')
    // this.findContentById('visionMissionDescription7')
    // this.findContentById('visionMissionTitle8')
    // this.findContentById('visionMissionDescription8')
    // this.findContentById('serviceTitleTop')
    // this.findContentById('serviceTitleMid')
    // this.findContentById('serviceTitleBot')
    // this.findContentById('serviceDynamicText1')
    // this.findContentById('serviceDynamicText2')
    // this.findContentById('serviceDynamicText3')
    // this.findContentById('serviceDynamicText4')
    // this.findContentById('serviceDynamicText5')
    // this.findContentById('serviceDynamicText6')
    // this.findContentById('serviceDynamicText7')
    // this.findContentById('serviceDynamicText8')
    // this.findContentById('serviceDynamicText9')
    // this.findContentById('serviceDynamicText10')
    // this.findContentById('serviceDynamicText11')
    // this.findContentById('serviceDynamicText12')
    // this.findContentById('serviceDynamicText13')
    // this.findContentById('projectTitleTop')
    // this.findContentById('projectTitleMid')
    // this.findContentById('projectTitleBot')
    // this.findContentById('productTitleTop')
    // this.findContentById('productTitleMid')
    // this.findContentById('productTitleBot')
    // this.findContentById('contactTitleMid')
    // this.findContentById('contactTitleBot')
    // this.findContentById('contactDynamicText1')
    // this.findContentById('contactDynamicText2')
    // this.findContentById('contactDynamicText3')
    // this.findContentById('contactDynamicText4')
    // this.findContentById('aboutUsFooter')
    // this.findContentById('subscribeFooter')
    // this.findContentById('socialMediaFooter')
  },
  computed: {
    ...mapGetters([
      'phoneNumber', 'phoneNumberId',
      'homeTitleTop', 'homeTitleTopId', 'homeTitleMid', 'homeTitleBot', 'homeDynamicText1', 'homeDynamicText2', 'homeDynamicText3',
      'aboutTitleTop', 'aboutTitleMid', 'aboutTitleBot', 'aboutDynamicText1', 'aboutDynamicText2', 'aboutWhyUsTitle1', 'aboutWhyUsDescription1', 'aboutWhyUsTitle2', 'aboutWhyUsDescription2', 'aboutWhyUsTitle3', 'aboutWhyUsDescription3', 'aboutWhyUsTitle4', 'aboutWhyUsDescription4',
      'visionMissionTitle1', 'visionMissionDescription1', 'visionMissionTitle2', 'visionMissionDescription2', 'visionMissionTitle3', 'visionMissionDescription3', 'visionMissionTitle4', 'visionMissionDescription4', 'visionMissionTitle5', 'visionMissionDescription5', 'visionMissionTitle6', 'visionMissionDescription6', 'visionMissionTitle7', 'visionMissionDescription7', 'visionMissionTitle8', 'visionMissionDescription8',
      'serviceTitleTop', 'serviceTitleMid', 'serviceTitleBot', 'serviceDynamicText1', 'serviceDynamicText2', 'serviceDynamicText3', 'serviceDynamicText4', 'serviceDynamicText5', 'serviceDynamicText6', 'serviceDynamicText7', 'serviceDynamicText8', 'serviceDynamicText9', 'serviceDynamicText10', 'serviceDynamicText11', 'serviceDynamicText12', 'serviceDynamicText13',
      'projectTitleTop', 'projectTitleMid', 'projectTitleBot',
      'productTitleTop', 'productTitleMid', 'productTitleBot',
      'contactTitleMid', 'contactTitleBot', 'contactDynamicText1', 'contactDynamicText2', 'contactDynamicText3', 'contactDynamicText4',
      'aboutUsFooter', 'subscribeFooter', 'socialMediaFooter',
      'homeTitleMidId', 'homeTitleBotId', 'homeDynamicText1Id', 'homeDynamicText2Id', 'homeDynamicText3Id',
      'aboutTitleTopId', 'aboutTitleMidId', 'aboutTitleBotId', 'aboutDynamicText1Id', 'aboutDynamicText2Id', 'aboutWhyUsTitle1Id', 'aboutWhyUsDescription1Id', 'aboutWhyUsTitle2Id', 'aboutWhyUsDescription2Id', 'aboutWhyUsTitle3Id', 'aboutWhyUsDescription3Id', 'aboutWhyUsTitle4Id', 'aboutWhyUsDescription4Id',
      'visionMissionTitle1Id', 'visionMissionDescription1Id', 'visionMissionTitle2Id', 'visionMissionDescription2Id', 'visionMissionTitle3Id', 'visionMissionDescription3Id', 'visionMissionTitle4Id', 'visionMissionDescription4Id', 'visionMissionTitle5Id', 'visionMissionDescription5Id', 'visionMissionTitle6Id', 'visionMissionDescription6Id', 'visionMissionTitle7Id', 'visionMissionDescription7Id', 'visionMissionTitle8Id', 'visionMissionDescription8Id',
      'serviceTitleTopId', 'serviceTitleMidId', 'serviceTitleBotId', 'serviceDynamicText1Id', 'serviceDynamicText2Id', 'serviceDynamicText3Id', 'serviceDynamicText4Id', 'serviceDynamicText5Id', 'serviceDynamicText6Id', 'serviceDynamicText7Id', 'serviceDynamicText8Id', 'serviceDynamicText9Id', 'serviceDynamicText10Id', 'serviceDynamicText11Id', 'serviceDynamicText12Id', 'serviceDynamicText13Id',
      'projectTitleTopId', 'projectTitleMidId', 'projectTitleBotId',
      'productTitleTopId', 'productTitleMidId', 'productTitleBotId',
      'contactTitleMidId', 'contactTitleBotId', 'contactDynamicText1Id', 'contactDynamicText2Id', 'contactDynamicText3Id', 'contactDynamicText4Id',
      'aboutUsFooterId', 'subscribeFooterId', 'socialMediaFooterId'
    ])
  },
  watch: {
    homeTitleTop (val) {
      this.$data.mHomeTitleTop = val
    },
    phoneNumber (val) {
      this.$data.mphoneNumber = val
    },
    homeTitleMid (val) {
      this.$data.mhomeTitleMid = val
    },
    homeTitleBot (val) {
      this.$data.mhomeTitleBot = val
    },
    homeDynamicText1 (val) {
      this.$data.mhomeDynamicText1 = val
    },
    homeDynamicText2 (val) {
      this.$data.mhomeDynamicText2 = val
    },
    homeDynamicText3 (val) {
      this.$data.mhomeDynamicText3 = val
    },
    aboutTitleTop (val) {
      this.$data.maboutTitleTop = val
    },
    aboutTitleMid (val) {
      this.$data.maboutTitleMid = val
    },
    aboutTitleBot (val) {
      this.$data.maboutTitleBot = val
    },
    aboutDynamicText1 (val) {
      this.$data.maboutDynamicText1 = val
    },
    aboutDynamicText2 (val) {
      this.$data.maboutDynamicText2 = val
    },
    aboutWhyUsTitle1 (val) {
      this.$data.maboutWhyUsTitle1 = val
    },
    aboutWhyUsDescription1 (val) {
      this.$data.maboutWhyUsDescription1 = val
    },
    aboutWhyUsTitle2 (val) {
      this.$data.maboutWhyUsTitle2 = val
    },
    aboutWhyUsDescription2 (val) {
      this.$data.maboutWhyUsDescription2 = val
    },
    aboutWhyUsTitle3 (val) {
      this.$data.maboutWhyUsTitle3 = val
    },
    aboutWhyUsDescription3 (val) {
      this.$data.maboutWhyUsDescription3 = val
    },
    aboutWhyUsTitle4 (val) {
      this.$data.maboutWhyUsTitle4 = val
    },
    aboutWhyUsDescription4 (val) {
      this.$data.maboutWhyUsDescription4 = val
    },
    visionMissionTitle1 (val) {
      this.$data.mvisionMissionTitle1 = val
    },
    visionMissionDescription1 (val) {
      this.$data.mvisionMissionDescription1 = val
    },
    visionMissionTitle2 (val) {
      this.$data.mvisionMissionTitle2 = val
    },
    visionMissionDescription2 (val) {
      this.$data.mvisionMissionDescription2 = val
    },
    visionMissionTitle3 (val) {
      this.$data.mvisionMissionTitle3 = val
    },
    visionMissionDescription3 (val) {
      this.$data.mvisionMissionDescription3 = val
    },
    visionMissionTitle4 (val) {
      this.$data.mvisionMissionTitle4 = val
    },
    visionMissionDescription4 (val) {
      this.$data.mvisionMissionDescription4 = val
    },
    visionMissionTitle5 (val) {
      this.$data.mvisionMissionTitle5 = val
    },
    visionMissionDescription5 (val) {
      this.$data.mvisionMissionDescription5 = val
    },
    visionMissionTitle6 (val) {
      this.$data.mvisionMissionTitle6 = val
    },
    visionMissionDescription6 (val) {
      this.$data.mvisionMissionDescription6 = val
    },
    visionMissionTitle7 (val) {
      this.$data.mvisionMissionTitle7 = val
    },
    visionMissionDescription7 (val) {
      this.$data.mvisionMissionDescription7 = val
    },
    visionMissionTitle8 (val) {
      this.$data.mvisionMissionTitle8 = val
    },
    visionMissionDescription8 (val) {
      this.$data.mvisionMissionDescription8 = val
    },
    serviceTitleTop (val) {
      this.$data.mserviceTitleTop = val
    },
    serviceTitleMid (val) {
      this.$data.mserviceTitleMid = val
    },
    serviceTitleBot (val) {
      this.$data.mserviceTitleBot = val
    },
    serviceDynamicText1 (val) {
      this.$data.mserviceDynamicText1 = val
    },
    serviceDynamicText2 (val) {
      this.$data.mserviceDynamicText2 = val
    },
    serviceDynamicText3 (val) {
      this.$data.mserviceDynamicText3 = val
    },
    serviceDynamicText4 (val) {
      this.$data.mserviceDynamicText4 = val
    },
    serviceDynamicText5 (val) {
      this.$data.mserviceDynamicText5 = val
    },
    serviceDynamicText6 (val) {
      this.$data.mserviceDynamicText6 = val
    },
    serviceDynamicText7 (val) {
      this.$data.mserviceDynamicText7 = val
    },
    serviceDynamicText8 (val) {
      this.$data.mserviceDynamicText8 = val
    },
    serviceDynamicText9 (val) {
      this.$data.mserviceDynamicText9 = val
    },
    serviceDynamicText10 (val) {
      this.$data.mserviceDynamicText10 = val
    },
    serviceDynamicText11 (val) {
      this.$data.mserviceDynamicText11 = val
    },
    serviceDynamicText12 (val) {
      this.$data.mserviceDynamicText12 = val
    },
    serviceDynamicText13 (val) {
      this.$data.mserviceDynamicText13 = val
    },
    projectTitleTop (val) {
      this.$data.mprojectTitleTop = val
    },
    productTitleTop (val) {
      this.$data.mproductTitleTop = val
    },
    productTitleMid (val) {
      this.$data.mproductTitleMid = val
    },
    productTitleBot (val) {
      this.$data.mproductTitleBot = val
    },
    projectTitleMid (val) {
      this.$data.mprojectTitleMid = val
    },
    projectTitleBot (val) {
      this.$data.mprojectTitleBot = val
    },
    contactTitleMid (val) {
      this.$data.mcontactTitleMid = val
    },
    contactTitleBot (val) {
      this.$data.mcontactTitleBot = val
    },
    contactDynamicText1 (val) {
      this.$data.mcontactDynamicText1 = val
    },
    contactDynamicText2 (val) {
      this.$data.mcontactDynamicText2 = val
    },
    contactDynamicText3 (val) {
      this.$data.mcontactDynamicText3 = val
    },
    contactDynamicText4 (val) {
      this.$data.mcontactDynamicText4 = val
    },
    aboutUsFooter (val) {
      this.$data.maboutUsFooter = val
    },
    subscribeFooter (val) {
      this.$data.msubscribeFooter = val
    },
    socialMediaFooter (val) {
      this.$data.msocialMediaFooter = val
    }
  }
}
</script>

<style scoped>
.settings {
  min-height: 100vh;
}
.title {
  border-bottom: 1px solid #ccc;
}
.sectionTitle {
  font-size: 1em;
}
.fieldWrapper {
  background-color: #fff;
  overflow: hidden;
  position: relative;
	display: inline;
}
.fieldWrapper input {
  border: none;
  border-bottom: 1px solid #000;
  padding: 10px 10px 10px 70px;
  width: 100%;
  outline: none;
  line-height: 1.5;
}
.prefixIcon {
  background-color: #FF8F00;
  position: absolute;
  top: -11px;
  bottom: -11px;
  font-size: 2em;
  padding: 0px 20px;
  color: #fff;
}
.actionBtn {
  background-color: #FF8F00;
  color: #FFF;
  padding: 10px 5px;
  margin-bottom: 10px;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.actionBtn:hover {
  background-color: #FFA000;
  color: #000;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue